import React, { useState,useContext } from 'react';
import {Link} from "react-router-dom";
import { useMst,RootStoreContext }  from '../models/root';
import { observer } from "mobx-react-lite";
import apis from "../assets/js/apis.js";
import axios from 'axios';
import firebase from "firebase/app";


const SERVER_ERROR = 1;
const CLIENT_ERROR = 2;
const FIREBASE_LOGIN_ATTEMPT_FAILED = 3;
const INVALID_USERNAME = 4;


const SignIn = observer(() => {
  const { variables } = useContext(RootStoreContext);



  const [success, setSuccess] = useState(false)
  const [failure, setFailure] = useState(false)
  const [em, setEM] = useState("")
  const [pa, setPA] = useState("")
  const [loading, setLoading] = useState(false)

  return (
      <div>
          <div class="text-center mt-8">Welcome back to Horsey!</div>
          <div class="text-center">You can sign in below</div>
          <form>
          <div class="flex mt-6"><div class="m-auto w-10/12">Email</div></div>
          <div class="flex mb-6 w-full"><input type="email" class=" rounded-2xl border-2 border-black m-auto w-10/12 h-12 p-2"/></div>

          <div><div class="m-auto w-10/12">Password</div></div>
          <div class="flex mb-2 w-full"><input type="password" class=" rounded-2xl border-2 border-black m-auto w-10/12 h-12 p-2"/></div>
          {failure&&<div class="mb-6">Your username and password combination is incorrect</div>}
          <div class="flex w-full my-4"><button class="py-2 px-4 rounded-xl bg-blue-700 text-white m-auto">
            Sign In
          </button>
          </div>
          </form>
              <div class="px-8 text-center "><Link to="/admissible">
                {"Don't have an account? Sign Up"}
              </Link>
              </div>
          </div>
  );
})


export default SignIn;




// function signInFunc(){
//   let obj = {
//     "email":em,
//     "password":pa,
//   }
  
//   firebase.auth().signInWithEmailAndPassword(em, pa)
//   .then((userCredential) => {
//     var user = userCredential.user;
//     return axios.post(apis.access,obj)
//   },error=>{;}).then(response=>{
//     if(response.data.detail=="No active account found with the given credentials"){
      
//     }
//     if(response.data.access){
//       variables._access_token(response.data.access);
//       variables._refresh_token(response.data.refresh);
//     }
//     const options = {
//       headers: {'Authorization': `Bearer ${response.data.access_token}`}
//     };  
//     return axios.get(apis.sendvariables,options)
//   },error=>{;}).then(response=>{
//     if(response.data.nominated == true){
//        if(window.location.pathname=("/"||"/beforeSignUp"||"/signIn"||"/signUp"||"/college"||"/home")){
//           setLoading(false);
//           history.push("/home");
//        }
//        else {
//           setLoading(false);
//           history.push(window.location.pathname);
//        }
//     }
//     else if(response.data.nominated==false){
//        if(response.data.college==true){
//           setLoading(false);
//           history.push("/nominate");
//        }
//        else if (response.data.college=false){
//           setLoading(false);
//           history.push("/college");
//        }
//     }
//  },error=>{;})
//   .catch((error) => {
//     var errorCode = error.code;
//     var errorMessage = error.message;
//   });

// }
